import styled from 'styled-components';
import { Button } from '@mui/material';

export const RedButton = styled(Button)`
  && {
    background-color: #f00;
    color: white;
    margin-left: 4px;
    &:hover {
      background-color: #eb7979;
      border-color: #f26767;
      box-shadow: none;
    }
  }
`;

export const BlackButton = styled(Button)`
  && {
    background-color: #000000;
    color: white;
    margin-left: 4px;
    &:hover {
      background-color: #212020;
      border-color: #212020;
      box-shadow: none;
    }
  }
`;

export const DarkRedButton = styled(Button)`
  && {
    background-color: #650909;
    color: white;
    &:hover {
      background-color: #eb7979;
      border-color: #f26767;
      box-shadow: none;
    }
  }
`;

export const BlueButton = styled(Button)`
  && {
    background-color: #080a43;
    color: #fff;
    &:hover {
      background-color: #0a1e82;
    }
  }
`;

export const PurpleButton = styled(Button)`
  && {
    background-color: #270843;
    color: #fff;
    &:hover {
      background-color: #3f1068;
    }
  }
`;

export const LightPurpleButton = styled(Button)`
  && {
    background-color: #7f56da;
    color: #fff;
    &:hover {
      background-color: #7a1ccb;
    }
  }
`;

export const WhiteWithIndigoBorderButton = styled(Button)`
  && {
    background-color: rgb(255, 255, 255);
    color: black;
    border: 1px solid  #2f2b80;;
    box-shadow: 0px 4px 12px rgba(122, 28, 203, 0.3); /* subtle purple shadow */

    &:hover {
      background-color: rgb(240, 240, 240);
      border: 1px solidrgb(104, 24, 175);
      box-shadow: 0px 6px 16px rgba(122, 28, 203, 0.4); /* stronger on hover */
    }
  }
`;


export const GreenButton = styled(Button)`
  && {
    background-color: #133104;
    color: #fff;
    &:hover {
      background-color: #266810;
    }
  }
`;

export const BrownButton = styled(Button)`
  && {
    background-color: #2c1006;
    color: white;
    &:hover {
      background-color: #40220c;
      border-color: #40220c;
      box-shadow: none;
    }
  }
`;

export const IndigoButton = styled(Button)`
  && {
    background-color:rgb(39, 31, 201);
    color: white;
    box-shadow: 0px 4px 12px rgba(122, 28, 203, 0.3);
    &:hover {
      background-color:rgb(64, 77, 193);
      border-color:rgb(67, 77, 195);
      box-shadow: 0px 4px 12px rgba(122, 28, 203, 0.4);
    }
  }
`;
